import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
function removeLocalStorage(key) {
    if (globalThis.localStorage) {
        return globalThis.localStorage.removeItem(key);
    }
}
function getLocalStorage(key) {
    return globalThis.localStorage ? globalThis.localStorage.getItem(key) : "";
}
function setLocalStorage(key, val) {
    if (globalThis.localStorage) {
        globalThis.localStorage.setItem(key, val);
    }
    return val;
}
function loadEndDate(name, unique_id) {
    const data = JSON.parse(getLocalStorage(name) || "{}");
    if (!data.end || data.id !== unique_id) {
        // No data, or non-matching unique id
        return undefined;
    }
    try {
        return new Date(data.end);
    }
    catch (_a) {
        // invalid date string, treat as no end time
        return undefined;
    }
}
export function TimeRemainingWrapper(props) {
    const { name, unique_id, value, interval = 1000, onReachZero } = props;
    const [secondsLeft, setSecondsLeft] = useState(Math.max(value, 0));
    // Calculate timeRemaining directly from secondsLeft
    const timeRemaining = React.useMemo(() => {
        return {
            seconds: (secondsLeft % 60).toString().padStart(2, "0"),
            minutes: Math.floor(secondsLeft / 60)
                .toString()
                .padStart(2, "0"),
            total_seconds: secondsLeft,
        };
    }, [secondsLeft]);
    useEffect(() => {
        const now = Date.now();
        const endTime = now + value * 1000;
        const data = { id: unique_id, end: new Date(endTime).toISOString() };
        setLocalStorage(name, JSON.stringify(data));
        const updateCountdown = () => {
            const currentTime = Date.now();
            const storedEndTime = loadEndDate(name, unique_id);
            if (!storedEndTime) {
                setSecondsLeft(0);
                return false;
            }
            let remaining = Math.ceil((storedEndTime.getTime() - currentTime) / 1000);
            if (remaining < 0) {
                remaining = 0;
            }
            setSecondsLeft(remaining);
            if (remaining <= 0) {
                removeLocalStorage(name);
                if (onReachZero) {
                    onReachZero();
                }
                return false;
            }
            return true;
        };
        const timer = setInterval(() => {
            const shouldContinue = updateCountdown();
            if (!shouldContinue) {
                clearInterval(timer);
            }
        }, interval);
        return () => {
            clearInterval(timer);
        };
    }, [name, unique_id, interval, onReachZero, value]);
    // Add the time_remaining prop to all the children of this component.
    const childrenWithProps = React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { time_remaining: timeRemaining });
        }
        return child;
    });
    return (_jsxs(_Fragment, { children: [props.debug && _jsx(RenderDebugInfo, Object.assign({}, props, { secondsLeft: secondsLeft })), childrenWithProps] }));
}
function RenderDebugInfo(props) {
    const end2 = loadEndDate(props.name, props.unique_id) || new Date();
    const now2 = new Date();
    const diff2 = Math.floor((end2.getTime() - now2.getTime()) / 1000);
    return (_jsxs("div", { className: "time-remaining-wrapper-debug", children: ["Debug info:", _jsx("div", { children: getLocalStorage(props.name) }), _jsx("div", { children: `${props.name} ends at ${end2.toISOString()}` }), _jsx("div", { children: `now ${now2.toISOString()}, diff ${diff2}` }), _jsx("div", { children: `secondsLeft ${props.secondsLeft}` })] }));
}
